import { roomPeriods } from '@app/lib/MyEnergy/RoomPeriods'

const convertRoomStats = (initial) => roomPeriods.map(
  (el) => ({ period: el, energy: initial[el].energy, billing: initial[el].billing }),
)

export default convertRoomStats
